// actionTypes.ts
export const MM_RFQ_FORM_DATA = "MM_RFQ_FORM_DATA";
export const RESET_MM_RFQ_FORM_DATA = "RESET_MM_RFQ_FORM_DATA";
export const UPDATE_MM_RFQ_FORM_ITEM = "UPDATE_MM_RFQ_FORM_ITEM";
export const UPDATE_SELECTED_VENDORS = "UPDATE_SELECTED_VENDORS";
